export const navigation = {
  SlotsByConfig: {
    labelKey: 'navigation.slots',
    route: '/',
    hidden: true
  }
}
